// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "eko-content-manager.firebaseapp.com",
  projectId: "eko-content-manager",
  storageBucket: "eko-content-manager.firebasestorage.app",
  messagingSenderId: "57736726326",
  appId: "1:57736726326:web:1513ad7ecce32b186dd597"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };